import React from "react";
import { Datagrid, List, ReferenceField, TextField } from "react-admin";

const CampaignChallengeList = (props) => (
	<List
		sort={{
			field: "campaign.created_date",
			order: "DESC",
		}}
		{...props}
	>
		<Datagrid rowClick="edit">
			<ReferenceField
				label="Campagne"
				source="campaign_id"
				reference="campaign"
				basePath="/campaign"
				link="show"
			>
				<TextField source="abstract_title" />
			</ReferenceField>
			<ReferenceField
				label="Défis"
				source="challenge_id"
				reference="challenge"
				basePath="/challenge"
				link="show"
			>
				<TextField source="abstract_title" />
			</ReferenceField>
		</Datagrid>
	</List>
);

export default CampaignChallengeList;
